var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-error_svg__Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-error_svg__Layout-\\u2013-Live-\\u2013-Error-\\u2013-Tablet",
    transform: "translate(-350 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-error_svg__Empty",
    transform: "translate(99 246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-error_svg__Group-5",
    transform: "translate(251)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icon-error_svg__Oval-2",
    fill: "#8498A4",
    fillRule: "nonzero",
    cx: 34.146,
    cy: 34.146,
    r: 34.146
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-error_svg__Group-2",
    transform: "translate(17 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.638 1.748L32.416 28.35A1.111 1.111 0 0131.445 30H1.888a1.111 1.111 0 01-.97-1.65L15.694 1.747a1.111 1.111 0 011.943 0z",
    id: "icon-error_svg__Triangle",
    stroke: "#1A2E3B",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "icon-error_svg__Oval",
    fill: "#1A2E3B",
    cx: 16.667,
    cy: 23.333,
    r: 1.111
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-error_svg__Line",
    stroke: "#1A2E3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    d: "M16.667 13.333v6"
  }))))))));
}
export default SvgIconError;